import { Dialog } from '@mui/material';
import { DialogProps } from '@mui/material/Dialog';
import { styled } from '@mui/system';

import { colors } from '@utils/constants';

const StyledDialog = styled(Dialog)<DialogProps>(() => ({
  backdropFilter: 'blur(2px)',
  backgroundBlendMode: 'multiply',
  backgroundImage: colors.modalBackdropColor,
  '& .MuiBackdrop-root': {
    backgroundColor: 'transparent',
  },
}));

export default StyledDialog;
